import Footer from './Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/index.tsx